module.exports = __webpack_public_path__ + "img/micro_tech_logo.6d5bbe7a.png";